import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'dictName',
      type: 'input',
      label: '字典名称',
    },
    {
      field: 'dictCode',
      type: 'input',
      label: '字典编码',
    }
  ]
}
